import HeaderSpan from './HeaderSpan'
import SailStatItem from './SailStatItem'
import { useLang, useMobile } from '../utils/hooks'
import { langRigsStats } from '../assets/langRigsStats.js'
import { sailColors } from '../assets/colors'

const SailStatList = ({
  list,
  handleSelectNewItem,
  handleSort,
  chLang,
  textClass,
}) => {
  const { mobile } = useMobile()
  const background = sailColors.headerCl
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langRigsStats.fr : langRigsStats.eng
  const listStats = list.listSailStatsPage
  const sortOrder = list.sortOrder.isReverse
  const sortType = list.sortOrder.sortType

  const onSort = (columnType) => {
    handleSort(columnType)
  }

  const handleClickOnItem = (event) => {
    /* let itemId = event.target.id
    const item = listStats.filter((stat) => {
      return Number(itemId) === stat.year
    })[0]
    handleSelectNewItem(item) */
  }

  const w_a = !mobile
    ? ['8', '25', '13', '18', '18', '18']
    : ['17', '34', '22', '27'] // percentages

  let i = 0
  let row_i = 0

  return (
    <div className={'content ' + textClass}>
      <div className="block">
        <div style={{ display: 'flex', width: '100%' }}>
          <HeaderSpan
            headerTitle={choosenLang.active}
            background={background}
            columnType={'ACTIVE_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[i]}
            handleOnClick={onSort}
          />
          <HeaderSpan
            headerTitle={choosenLang.sail}
            background={background}
            columnType={'SAIL_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={onSort}
          />
          <HeaderSpan
            headerTitle={choosenLang.usedNb}
            background={background}
            columnType={'NB_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={onSort}
          />
          <HeaderSpan
            headerTitle={choosenLang.totalTime}
            background={background}
            columnType={'DURATION_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={onSort}
          />
          {!mobile && (
            <HeaderSpan
              headerTitle={choosenLang.firstUse}
              background={background}
              columnType={'FIRST_USE_SORT'}
              sortType={sortType}
              sortOrder={sortOrder}
              w={w_a[++i]}
              handleOnClick={onSort}
            />
          )}
          {!mobile && (
            <HeaderSpan
              headerTitle={choosenLang.lastUse}
              background={background}
              columnType={'LAST_USE_SORT'}
              sortType={sortType}
              sortOrder={sortOrder}
              w={w_a[++i]}
              handleOnClick={onSort}
            />
          )}
        </div>
      </div>
      <div className="block">
        {listStats.map((oneStat) => {
          row_i++ //test
          return (
            <SailStatItem
              key={oneStat.sail}
              stat={oneStat}
              onClick={handleClickOnItem}
              isGrey={row_i % 2 === 1}
              isSelected={oneStat.bg}
              wA={w_a}
            ></SailStatItem>
          )
        })}
      </div>
    </div>
  )
}

export default SailStatList
